import React, { Component } from "react";
import { connect } from "react-redux";

import { selectLoggedAs, selectNavCommunity } from "Selectors";
import { setMenuDirection } from "Actions";
import SubMenuComponent from "./SubMenuComponent";

export class SubMenuContainer extends Component {
  setMenuDirection = e => {
    const { direction, setMenuDirection } = this.props;

    setMenuDirection(direction === "HORIZONTAL" ? "VERTICAL" : "HORIZONTAL");
  };
  render() {
    const { loggedAs, navCommunity, direction } = this.props;

    if (loggedAs === "GUEST" || !navCommunity) {
      return null;
    }
    return (
      <SubMenuComponent
        navCommunity={navCommunity}
        direction={direction}
        changeMenuDirection={this.setMenuDirection}
      />
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  loggedAs: selectLoggedAs(state),
  navCommunity: selectNavCommunity(state),
  direction: state.params.menu
});
const mapDispatchToProps = dispatch => ({
  setMenuDirection: dir => dispatch(setMenuDirection(dir))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubMenuContainer);



// WEBPACK FOOTER //
// ./src/components/Menu/SubMenu/SubMenuContainer.js